import { Redirect, useSegments, type Href } from "expo-router";
import type { PropsWithChildren } from "react";
import { Platform } from "react-native";
import { useStartup } from "../hooks/useStartup";
import { StartupStateScreen } from "./StartupStateScreen";

export function NativeStartupGate({ children }: PropsWithChildren) {
  const { status, retry } = useStartup();
  const segments = useSegments();

  let content = children;
  if (Platform.OS !== "web" && segments[0] !== "(auth)") {
    if (status === "loading") content = <StartupStateScreen mode="loading" />;
    else if (status === "signed_out") content = <Redirect href="/(auth)/login" />;
    else if (status === "email_verification_required") content = <Redirect href={"/(auth)/verify-email" as Href} />;
    else if (status === "onboarding_required") content = <Redirect href="/(auth)/onboarding" />;
    else if (status === "offline" || status === "recoverable_error") {
      content = <StartupStateScreen mode="error" offline={status === "offline"} onRetry={retry} />;
    }
  }

  return content;
}
